import React, { useEffect, useState } from "react";
// import "./MobileSlider.css";
import "./ChildrenBooksSlider.css"
import { Select } from "antd";
import { Citys, cities, location1 } from "../../component/Location";
import { ChildrenBooks } from "../../component/env";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getExtraField } from "../../store/ProductFilterSlice";
const images = [
    "https://news.harvard.edu/wp-content/uploads/2020/12/kids-books-header.jpg",
    "https://theforgotteninitiative.org/wp-content/uploads/2019/09/Story-Time-Books-For-Children-In-Foster-Care-Updated-2021.jpg",
    "https://assets.theschooloflife.com/wp-content/uploads/2023/07/12093530/TSOL.WAYWF0477__93631.1689154521.1280.1280.jpg",
    "https://www.scholastic.com/content/dam/parents/FeatureImages/book-lists/022224-books-about-kindness-4-3.png",
    "https://www.mindful.org/content/uploads/7-classic-childrens-books-with-mindfulness-messages.jpg",
    "https://s3.ap-south-1.amazonaws.com/assets.klayschools.com/wp-content/uploads/2023/07/07060942/Banner-images-1.jpg"
];

const ChildrenBooksSlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible1, setVisible1] = useState(false);
    const handleDropdownVisibleChange = (open) => {
        setVisible1(open);
    };
    const [visible2, setVisible2] = useState(false);
    const handleDropdownVisibleChange2 = (open) => {
        setVisible2(open);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const mobilestyle = {
        height: "200px",
        width: "100%",
    };
    const desktopstyle = {
        height: "340px",
        width: "90%",
        marginLeft: "1.5cm",
        marginRight: "2.5cm",
        borderRadius: "20px",
    };
    const mobstyle = {
        display: "flex",
        flexDirection: "column",
    };
    const deskstyle = {
        display: "flex",
        flexDirection: "row",
    };

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [loading, setLoading] = useState(false); // Setting up a state variable 'loading' and its setter function 'setLoading' with initial value 'false'
    const disptach = useDispatch();
    const dispatch = useDispatch();
    // Accessing the Redux dispatch function
    const [errorMessage, setErrorMessage] = useState(null);
    const [extraFieldCopy, setExtraFieldCopy] = useState({});
    const [city, setCity] = useState();
    const [category, setCategory] = useState();
    const [cityError, setCityError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [searchSending, setsearchSending] = useState({
        subCategoryType: null,
        subCategoryValue: null,
        City: null,
        searchValue: null,
        category: "ChildrenBooks",
        minPrice: null,
        maxPrice: null,
    }); // State for search form data

    //   const disptach = useDispatch(); // Initializing useDispatch hook

    // Event handler for input field changes
    const handleChange = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setExtraFieldCopy({ [name]: value });
        // setsearchSending({ ...searchSending, [name]: value });
        // disptach(getExtraField(searchSending)); // Dispatching getExtraField action
    };

    useEffect(() => {
        // Update searchSending state with the selected filter value
        if (selectedFilter !== null) {
            setsearchSending((prevState) => ({
                ...prevState,
                category: selectedFilter,
            }));
        }
    }, [selectedFilter]);
    return (
        <>
            <div
                className="techslide tech-slide-awi-26 mt-4 mb-3"
            // style={isMobile ? mobstyle : deskstyle}
            >
                <div className="search-form-awi-26">
                    <h1
                        style={{
                            fontSize: "20px",
                            fontFamily: "times",
                            borderBottom: "1px double white",
                            borderTop: "1px double white",
                            fontWeight: "bold",
                            color: "brown",
                        }}
                    >
                        SEARCH FOR CHILDREN'S BOOKS
                    </h1>
                    <div className="form-group2 mt-3">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select City :
                        </h6>
                        <Select
                            open={visible1}
                            onDropdownVisibleChange={handleDropdownVisibleChange}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{
                                width: "15rem",
                                padding: "5px 0px",
                            }}
                            placeholder="Select City"
                            onChange={(value) => setCity(value)}
                            options={Citys.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                            showSearch={true}
                            filterOption={(inputValue, option) =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                            }
                        />
                        {cityError && <p className="error-message">{cityError}</p>}
                    </div>
                    <div className="form-group2">
                        <h6
                            style={{
                                fontFamily: "verdana",
                                color: "gray",
                                fontWeight: "bold",
                                fontSize: "14px",
                            }}
                        >
                            Select Category :
                        </h6>
                        <Select
                            open={visible2}
                            onDropdownVisibleChange={handleDropdownVisibleChange2}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            style={{ width: "15rem" }}
                            placeholder="select category"
                            value={category || null}
                            onChange={(value) => setCategory(value)}
                            options={ChildrenBooks.map((value) => ({
                                value: value,
                                label: value,
                            }))}
                        />
                        {categoryError && <p className="error-message">{categoryError}</p>}
                    </div>
                    <Link
                        to={`/ads-listing/`}
                        onClick={(e) => {
                            if (!city || !category) {
                                e.preventDefault(); // Prevent the default navigation behavior
                                console.log("Please select both City and Category.");
                                setErrorMessage("Please select both City and Category."); // Set an error message
                            } else {
                                setErrorMessage(null); // Clear any previous error message

                                for (const key in searchSending) {
                                    if (
                                        searchSending[key]?.trim() === "" ||
                                        searchSending[key] === null
                                    ) {
                                        delete searchSending[key];
                                    }
                                }
                                searchSending["extraField"] = { ...extraFieldCopy };
                                searchSending["subCategoryValue"] = category;
                                searchSending["City"] = city;
                                disptach(getExtraField(searchSending));
                            }
                        }}
                    >
                        <button className="buttonno12">Search</button>
                    </Link>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>

                <div className="carousel-innertech24-awi-26">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-item${index === activeIndex ? " active" : ""
                                }`}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={isMobile ? mobilestyle : desktopstyle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ChildrenBooksSlider;